import React from 'react'
import './index.scss'
import { cn } from '~/utils/cn'

const DisplayCard = ({ children, inline = false, className, onClick }) => {
    return <div className={cn("display-card", inline && "display-card--inline", className, onClick && "display-card--interactable")} onClick={onClick}>{children}</div>
}

const Content = ({ children }) => {
    return <div className="display-card__content">{children}</div>
}

const Image = ({ children }) => {
    return <div className="display-card__image">{children}</div>
}

DisplayCard.Content = Content
DisplayCard.Image = Image

export default DisplayCard
